import classNames from 'classnames';
import * as React from 'react';
import styles from './Table.module.scss.js';

var defaultProps = {
    isActive: false,
    isHovering: false,
    isOwn: false,
    isDisabled: false,
};
var TableRow = function (props) {
    var _a;
    var classNameTr = classNames(styles.tr, (_a = {},
        _a[styles.isActive] = !props.isDisabled ? props.isActive : false,
        _a[styles.isHovering] = !props.isDisabled ? props.isHovering : false,
        _a[styles.isOwn] = props.isOwn,
        _a[styles.isDisabled] = props.isDisabled,
        _a), props.className);
    return (React.createElement("div", { className: classNameTr, id: props.isOwn ? 'ownScrollId' : undefined, onClick: !props.isDisabled ? props.onClick : function () { return null; }, onContextMenu: props.onContextMenu }, props.children));
};
TableRow.defaultProps = defaultProps;

export { TableRow as default };
//# sourceMappingURL=TableRow.js.map
